import { useState } from "react";
import axios from "axios";
import { rootURL } from "../constants";
import { link } from "fs";

console.log('[tommy] backend rootURL:', rootURL);

export const getUser = () => {
  const user = window.localStorage.getItem("user");
  return user ? user : "";
};

const getStoredToken = () => {
  return window.localStorage.getItem("tokens")
    ? JSON.parse(window.localStorage.getItem("tokens") || "")
    : "";
};

const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

const base64ToFile = (base64String: string, filename: string): File => {
  const arr = base64String.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  if (!mimeMatch) {
    throw new Error('Invalid base64 string');
  }
  const mime = mimeMatch[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${filename}`, { type: mime });
};

export const getSubscription = async () => {
  const user = window.localStorage.getItem("user");
  try {
    const response = await axios.post(`${rootURL}/authentication/get-subscription/`, { user: user });
    return response.data;
  } catch (error) {
    console.error('Error fetching subscription status:', error);
    return [];
  }
}

export const cancelSubscription = async () => {
  const user = window.localStorage.getItem("user");
  try {
    const response = await axios.post(`${rootURL}/authentication/cancel-subscription/`, { user: user });
    return response.data;
  } catch (error) {
    console.error('Error cancelling subscription:', error);
    return [];
  }
}

export const generateUserToken = async (user: string, regen: boolean = false) => {
  let currentToken = getStoredToken();
  const response = await axios.post(`${rootURL}/authentication/api-token-auth/`, { user: user, regen: regen },    
  {
    headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentToken.access}`
      },
        withCredentials: true
  });
  return response.data;
};

export const getUserInfo = () => {
  const user = getUser();
  let currentToken = getStoredToken();
  return axios.post(`${rootURL}/authentication/get-user-info/`, {'user': user}, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${currentToken.access}`
    },
    withCredentials: true
  })
  .then(response => {
    const data = response.data;
    const updatedProfile = {'name': '', 'surname': '', 'phone': '', 'linkedin_access_token': '', 'activated_email': false};

    if (data.name && data.name.trim() !== '') {
      updatedProfile.name = data.name;
    }
    if (data.last_name && data.last_name.trim() !== '') {
      updatedProfile.surname = data.last_name;
    }
    if (data.phone && data.phone.trim() !== '') {
      updatedProfile.phone = data.phone;
    }
    if (data.linkedin_access_token && data.linkedin_access_token.trim() !== '') {
      updatedProfile.linkedin_access_token = data.linkedin_access_token;
    }

    if (data.activated_email && data.activated_email.trim() !== '') {
      updatedProfile.activated_email = data.activated_email;
    }

    return { updatedProfile };
  })
  .catch(error => {
    console.error('Error fetching user info:', error);
    return { updatedProfile: null };
  });
};

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
};

export const callAgent = async (message: string, chatid: string = '', onMessage: (chunk: string) => void): Promise<{ chatid: string }> => {
  const user = getUser();
  const azureAccessToken = getCookie('azuread_token');
  const slackAccessToken = getCookie('slack_access_token');
  const firefliesAccessToken = getCookie('fireflies_access_token') || '';
  let currentToken = getStoredToken();
  let workspace_id = localStorage.getItem('currentWorkspaceId') || '';

  const response = await fetch(`${rootURL}/app/agents/stream/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${currentToken.access}`
    },
    body: JSON.stringify({
      message: message,
      user: user,
      azure_access_token: azureAccessToken,
      slack_access_token: slackAccessToken,
      fireflies_access_token: firefliesAccessToken,
      workspace_id: workspace_id,
      chatid: chatid
    }),
    credentials: 'include'
  });

  if (!response.body) {
    throw new Error('ReadableStream not supported in this browser.');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let responseChatid = chatid;

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    const chunk = decoder.decode(value, { stream: true });
    onMessage(chunk);
  }

  responseChatid = response.headers.get('chatid') || 'null';
  return { 'chatid': responseChatid };
};

export const getChat = async (chatid: string) => {
  const user = getUser();
  let currentToken = getStoredToken();
  const response = await axios.post(`${rootURL}/app/get-chat/`, 
    { user: user, chatid: chatid },
    {
      headers: { 
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${currentToken.access}`
      },
      withCredentials: true
    }
  );
  return response.data;
}

export const getChatList = async () => {
  const user = getUser();
  let currentToken = getStoredToken();
  const response = await axios.post(`${rootURL}/app/get-user-chats/`, { user: user },
    {
      headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
          withCredentials: true
    });
  return response.data;
}

export const uploadImage = async (image: File) => {
  let user = getUser();
  let currentToken = getStoredToken();
  const base64Image = await convertFileToBase64(image);
  const response = await axios.post(`${rootURL}/app/upload-image/`, { image: base64Image, user: user },    
  {
    headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentToken.access}`
      },
        withCredentials: true
  });
  return response.data;
}

export const uploadFile = async (file: File) => {
  let user = getUser();
  let currentToken = getStoredToken();
  let workspace_id = localStorage.getItem('currentWorkspaceId') || '';
  let onedrive_token = getCookie('azuread_token');
  
  // Create FormData for file upload
  const formData = new FormData();
  formData.append('file', file);
  formData.append('workspace_id', workspace_id);
  formData.append('onedrive_token', onedrive_token || '');
  
  const response = await axios.post(`${rootURL}/app/upload-file/`, formData, {
    headers: { 
      'Authorization': `Bearer ${currentToken.access}`,
      // Don't set Content-Type header - let axios set it automatically for FormData
    },
    withCredentials: true
  });
  return response.data;
}

export const list_user_workspaces = async () => {
  const user = getUser();
  let currentToken = getStoredToken();
  
  try {
    const response = await axios.post(`${rootURL}/authentication/list-user-workspaces/`, 
      { user: user },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user workspaces:', error);
    return [];
  }
}

export const create_workspace = async (name: string) => {
  const user = getUser();
  let currentToken = getStoredToken();
  let azuread_token = getCookie('azuread_token');
  
  try {
    const response = await axios.post(`${rootURL}/authentication/create-workspace/`, 
      { email: user, name: name, azuread_token: azuread_token },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
        withCredentials: true
    });
    return response.data;
  } catch (error: any) {
    console.error('Error creating workspace:', error);
    throw error;
  }
}

export const get_workspace_folder_url = async (workspaceName: string, userEmail: string, azureadToken: string) => {
  let currentToken = getStoredToken();
  
  try {
    const response = await axios.post(`${rootURL}/authentication/get-workspace-folder-url/`, 
      { 
        workspace_name: workspaceName,
        user: userEmail,
        azuread_token: azureadToken
      },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
        withCredentials: true
    });
    return response.data;
  } catch (error: any) {
    console.error('Error getting workspace folder URL:', error);
    throw error;
  }
}

export const remove_user_from_workspace = async (email: string, workspaceId: string) => {
  const user = getUser();
  let currentToken = getStoredToken();
  let azuread_token = getCookie('azuread_token');
  
  try {
    const response = await axios.post(`${rootURL}/authentication/manage-workspace-member/${workspaceId}/`, 
      { 
        action: 'remove',
        target_user_email: email,
        user: user,
        azuread_token: azuread_token
      },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`,
          'X-CSRFToken': getCookie('csrftoken') || ''
        },
        withCredentials: true
    });
    return response.data;
  } catch (error: any) {
    console.error('Error removing user from workspace:', error);
    throw error;
  }
}

export const add_user_to_workspace = async (email: string, workspaceId: string, role: string = 'member') => {
  const user = getUser();
  let currentToken = getStoredToken();
  let azuread_token = getCookie('azuread_token');
  try {
    const response = await axios.post(`${rootURL}/authentication/manage-workspace-member/${workspaceId}/`, 
      { 
        action: 'add_update',
        target_user_email: email,
        role: role,
        user: user,
        azuread_token: azuread_token
      },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`,
          'X-CSRFToken': getCookie('csrftoken') || ''
        },
        withCredentials: true
    });
    return response.data;
  } catch (error: any) {
    console.error('Error adding user to workspace:', error);
    throw error;
  }
}

export const is_first_time_user = async () => {
  const user = getUser();
  
  try {
    const response = await axios.post(`${rootURL}/authentication/is-first-time-user/`, 
      { user: user },
      {
        headers: { 
          'Content-Type': 'application/json',
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error checking first time user status:', error);
    return false;
  }
};

export const verifyInvitationToken = async (token: string) => {
  try {
    const response = await axios.post(`${rootURL}/authentication/verify-invitation-token/`, 
      { token: token },
      {
        headers: { 
          'Content-Type': 'application/json',
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying invitation token:', error);
    throw error;
  }
};

export const acceptInvitation = async (token: string, password: string) => {
  try {
    const response = await axios.post(`${rootURL}/authentication/accept-invitation/`, 
      { 
        token: token,
        password: password,
      },
      {
        headers: { 
          'Content-Type': 'application/json',
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error accepting invitation:', error);
    throw error;
  }
};

export const createInvitationToken = async (email: string) => {
  const currentToken = getStoredToken();
  
  try {
    const response = await axios.post(`${rootURL}/authentication/create-invitation-token/`, 
      { email: email },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error creating invitation token:', error);
    throw error;
  }
};

export const updateWorkspaceName = async (workspaceId: string, newName: string) => {
  const user = getUser();
  let currentToken = getStoredToken();
  
  try {
    const response = await axios.post(`${rootURL}/authentication/update-workspace-name/`, 
      { workspace_id: workspaceId, new_name: newName, user: user },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error updating workspace name:', error);
    throw error;
  }
};

export const sendResetPassword = async (email: string) => {
  try {
    const response = await axios.post(`${rootURL}/authentication/send-reset-password/`, 
      { email: email },
      {
        headers: { 
          'Content-Type': 'application/json',
        },
    });
    return response
  } catch (error) {
    console.error('Error sending reset password:', error);
    throw error;
  }
};

export const delete_workspace = async (workspaceId: string) => {
  const user = getUser();
  let currentToken = getStoredToken();
  
  try {
    const response = await axios.delete(`${rootURL}/authentication/delete-workspace/${workspaceId}/`, {
      data: { user: user },
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentToken.access}`
      },
      withCredentials: true
    });
    return response.data;
  } catch (error: any) {
    console.error('Error deleting workspace:', error);
    throw error;
  }
};

export const deleteChat = async (chatId: string) => {
  const user = getUser();
  let currentToken = getStoredToken();
  
  try {
    const response = await axios.delete(`${rootURL}/app/delete-chat/`, {
      data: { 
        chatid: chatId,
        user: user 
      },
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentToken.access}`
      },
      withCredentials: true
    });
    return response.data;
  } catch (error: any) {
    console.error('Error deleting chat:', error);
    throw error;
  }
};

export const getSlackWorkspaceName = async (slackAccessToken: string) => {
  let currentToken = getStoredToken();
  
  try {
    const response = await axios.post(`${rootURL}/authentication/get-slack-workspace-name/`, 
      { slack_token: slackAccessToken },
      {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${currentToken.access}`
        },
        withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error getting Slack workspace name:', error);
    throw error;
  }
};